import { render, staticRenderFns } from "./toUpdate.vue?vue&type=template&id=771015f1&scoped=true&"
import script from "./toUpdate.vue?vue&type=script&lang=js&"
export * from "./toUpdate.vue?vue&type=script&lang=js&"
import style0 from "./toUpdate.vue?vue&type=style&index=0&id=771015f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771015f1",
  null
  
)

export default component.exports